'use client';

import {
  AppHeader,
  AppHeaderStart,
  AppShell,
  SideNav,
  SideNavItem,
  SideNavLogo,
  Skeleton,
  Spinner,
} from '@lulalife/design-system';

const NAV_SKELETON_KEYS = Array.from({ length: 9 }, (_, index) => `nav-skeleton-${index}`);
const skeletonLabel = (<Skeleton width={164} height={24} rounded="sm" />) as unknown as string;

const NavigationSkeleton = () => (
  <div data-lula-ds="" className="h-full">
    <SideNav logo={<SideNavLogo logo="Foresight" type="Full" />} showSettings={false}>
      {NAV_SKELETON_KEYS.map((key) => (
        <SideNavItem key={key} label={skeletonLabel} />
      ))}
    </SideNav>
  </div>
);

export const CoordinatorContentSkeleton = () => (
  <div data-lula-ds="" className="flex min-h-0 flex-1 items-center justify-center">
    <Spinner size="lg" showLabel={false} />
  </div>
);

export const CoordinatorShellSkeleton = () => (
  <div data-lula-ds="" className="flex min-w-0 flex-1">
    <AppShell
      className="coordinator-app-shell"
      routeKey="loading"
      routeAnnouncement="Loading"
      navigation={<NavigationSkeleton />}
      header={
        // The real header chrome with a skeleton in place of the breadcrumb: no profile or
        // actions, since the user is not known yet.
        <AppHeader>
          <AppHeaderStart>
            <div aria-hidden="true">
              <Skeleton width={160} height={16} rounded="sm" />
            </div>
          </AppHeaderStart>
        </AppHeader>
      }
    >
      <CoordinatorContentSkeleton />
    </AppShell>
  </div>
);
